import React, { FormEvent, useState, useEffect } from "react";
import { useAuth } from "../store/AuthContext";
import Loading from "../components/Loading";
import { Alert, Button, Card, Form, Spinner } from "react-bootstrap";

const Home: React.FC = () => {
    // Достаем всё необходимое из контекста
    const { logIn, error, isLoading } = useAuth();



    // Локальные стейты для полей и валидации
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [formError, setFormError] = useState<string | null>(null);

    // Сбрасываем локальную ошибку, когда пользователь начинает вводить данные
    useEffect(() => {
        if (formError) setFormError(null);
    }, [email, password]);

    const handleSubmit = async (e: any) => {
        console.log(import.meta.env)
        e.preventDefault();
        setFormError(null);

        // Базовая валидация перед запросом
        if (!email.trim() || !password.trim()) {
            setFormError("Пожалуйста, заполните все поля");
            return;
        }

        // Вызываем логин.isLoading из контекста сам заблокирует кнопку
        await logIn(email, password);
    };

    // Если идет первичная проверка токена при загрузке страницы
    if (isLoading && !email) {
        return <Loading />;
    }

    return (
        <div className={"d-flex ai-center jc-center h-100 bg-light"}>
            <Card style={{ width: "28rem" }} >

                <Card.Header className={"p-3 bg-white h4 text-center"}>
                    Авторизация
                </Card.Header>

                <Card.Body className="p-4">
                    {/* Ошибка от сервера (из контекста) */}
                    {error && (<Alert variant="danger" dismissible={true}>{error}</Alert>)}

                    {/* Ошибка валидации формы (локальная) */}
                    {formError && (<Alert variant="warning" dismissible={true}>{formError}</Alert>)}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="login">
                            <Form.Label className="small fw-semibold text-muted">E-mail</Form.Label>
                            <Form.Control
                                autoFocus // Автофокус при загрузке
                                type="email"
                                placeholder="example@mail.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={isLoading}
                                className="py-2"
                            />
                        </Form.Group>

                        <Form.Group className="mb-4" controlId="password">
                            <Form.Label className="small fw-semibold text-muted">Пароль</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                disabled={isLoading}
                                className="py-2"
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit" disabled={isLoading} className="w-100 py-2 fw-bold d-flex ai-center jc-center">
                            {isLoading ? (<><Spinner as="span" animation="border" size="sm" className="me-2" />Вход...</>) : ("Войти в систему")}
                        </Button>
                    </Form>
                </Card.Body>

                <Card.Footer className="bg-white border-0  text-center">
                    <small className="text-muted">
                        Нет аккаунта? Обратитесь к администратору
                    </small>
                </Card.Footer>
            </Card>
        </div>
    );
};

export default Home;